import breakpoints from '../../../theme/breakpoints'
import theme from '../../../theme/news12'

import css from 'styled-jsx/css'

export default css.div`
  .main-layout-container {
    width: fit-content;
    margin: 0 auto;
    padding-top: 24px; 
  }

  .main-layout {
    display: inline-block;
    width: 728px;
    background-color: ${theme.colors.white};
  }
  
  .main-layout-sidebar {
    display: inline-block;
    vertical-align: top;
    margin-left: 14px;
    top: 120px;
  }
  
  .top-stories, .category {
    margin-top: 30px;
    padding-bottom: 4px;
  }
  
  .hero {
    margin-top: 30px;
  }
      
  .top-stories {
    margin-bottom: 30px;
  }
  
  .main-layout .top-stories,
  .main-layout .category {
    display: flex;
    flex-wrap: wrap;
  }
  
  .top-stories-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 20px;
  }
  
  .category-middleboard {
    margin: 40px auto;
  }

  .header-ny {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 37px;
  }

  .banner-section {
    display: grid;
    grid-template-areas: 'overlay';
  }

  .header-ny .banner-heading {
    grid-area: overlay;
    align-self: center;
    display: flex;
    flex-direction: column;
    font-size: 40px;
    text-transform: uppercase;
    color: ${theme.colors.white};
    text-align: center;
    white-space: break-spaces;
  }

  .platforms-list {
    margin: 25px 0;
  }

  .header-ny .wide-banner {
    width: 100vw;
    height: 100%;
    grid-area: overlay;
  }

  .ads-block {
    display: grid;
    grid-template-rows: 1fr 1fr;
    row-gap: 37px;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .header-ny .banner-heading {
      font-size: 30px;
    }
  }
  
  @media only screen and (max-width: ${breakpoints.md}px) {
    .main-layout-container {
      width: 100%;
      background-color: ${theme.colors.drWhite};
      padding-top: 20px;
    }

    .main-layout {
      display: block;
      background-color: ${theme.colors.drWhite};
      width: 100%;
    }

    .ny-landing {
      background-color: ${theme.colors.white};
    }

    .main-layout .description {
      padding: 0 24px; 
    }

    .projects-carousel {
      margin-left: 20px;
    }
    
    .top-stories, .category, .banner {
      margin-top: 24px;
    }    
    
    .category {
      margin-top: 24px;
    }
    
    .top-stories-list {
      display: none;
    }
    
    .category-middleboard {
      display: none;
    }

    .header-ny {
      margin-bottom: 0px;
    }

    .header-ny .banner-heading {
      font-size: 22px;
      padding: 10px 40px;
    }

    .header-ny .wide-banner {
      object-fit: cover;
    }
  }  
  
  @media only screen and (max-width: 1280px) {
    .main-layout-sidebar {
      display: none;
    }
  }
  
  @media only screen and (max-width: ${breakpoints.sm}px) {
    .main-layout .description {
      padding: 0 16px; 
    }

    .projects-carousel {
      margin-left: 24px;
    }
  }
`
